/* eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueHtmlToPaper from "./htmlToPaper";
import axios from "axios";
import moment from 'moment';
import numeral from 'numeral';


import 'vue-loading-overlay/dist/vue-loading.css';

axios.defaults.baseURL = 'http://payment.alkautsarlampung.sch.id';
axios.defaults.headers.common['Content-Type'] = 'application/json';
/*axios.defaults.headers.common['X-Api-Key'] = 'Xkjai83wkKsLAa2I9aPlas0Xasa2ZKla';*/
/*
if(localStorage.getItem('token')){
    let token = localStorage.getItem('token');
    axios.defaults.headers.common['Authorization'] = token;
}
*/

const app = createApp(App);
const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
      '/lib/bootstrap/css/bootstrap.min.css',
      '/css/style.css'
    ],
    timeout: 1000, // default timeout before the print window appears
    autoClose: true, // if false, the window will not close after printing
    windowTitle: window.document.title, // override the window title
}

app.config.globalProperties.$filters = {
  currencyUSD(value) {
    return numeral(value).format('0,0');
  },
  formatTanggal(value) {
    let newValue   = value.replace('-', '/');
    const setValue = newValue.split("/")
    let tahun  = setValue[0]
    if(tahun.length > 3) {
      let tanggal = moment(String(newValue)).format('DD/MM/YYYY');
      if(tanggal !== 'Invalid date') {
        return tanggal.replace('-', '');
      }
    }
    return newValue
  },
  formatTglView(value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
}

app.use(store).use(VueHtmlToPaper,options).use(router).mount("#app");
